define.alias("ember-math-helpers/helpers/cos", "settings/helpers/cos");